import { DICT_KEY, getDictNameByCode, getModel, setModel } from "../../../utils/constants";
import SaleRoService from "./SaleRoService";
import ModelUtils from "../../../utils/ModelUtils";
import moment from "moment";
import SaleSoService from "../so/SaleSoService";
import { v4 as uuidv4 } from "uuid";

const MODEL_KEY = DICT_KEY.SALE_RO;
const storageModel = getModel(MODEL_KEY);

//转换日期函数
function transRangePickerValue(obj, ...values) {
    if (!!!obj) return null;
    let tmp = obj;
    for (let i = 0; i < values.length; i++) {
        if (tmp[values[i]]) {
            tmp = tmp[values[i]]
        } else {
            break;
        }
        if (i === values.length - 1) {
            tmp[0] = moment(tmp[0])
            tmp[1] = moment(tmp[1])
        }
    }
}

// transRangePickerValue(storageModel, "searchParam", "startEndDate");
const cacheAble = false;
const saleRoModel = {
    state: cacheAble && storageModel ? storageModel : {
        //查询参数
        searchParam: {},
        //单据列表
        documentList: [],
        //销售订单统计信息
        documentStatistic: {},
        //单据列表分页信息
        documentPageInfo: {
            total: 0,
            pageNum: 1,
            pageSize: 15
        },
        //选中单据
        selectedDocument: {},
        //选中单据key数组
        selectedDocumentRowKeys: [],
        //单据打印窗口显示
        printDocumentModelVisible: false,

        //单据配件列表
        documentMaterialList: [],
        //选中配件
        selectedDocumentMaterial: null,
        //选中配件key数组
        selectedDocumentMaterialRowKeys: [],
        detailStatistics: {
            //销售总数
            saleTotalNum: 0,
            //退货总数量
            returnTotalNum: 0,
            //退货总金额
            returnTotalAmount: 0.00,
            //退货应付总金额
            payableTotalAmount: 0.00,
        },

        //添加物料窗口显示
        addMaterialModelVisible: false,
        materialSearchParam: {},
        //待选配件列表
        materialList: [],
        materialPageInfo: {
            total: 0,
            pageNum: 1,
            pageSize: 5
        },
        //已选配件列表
        selectedMaterialList: [],
        paymentDrawerVisible: false,

        formExpand: false,
        formData: {},
    },
    reducers: {
        toggleExpand(state, ) {
            state.formExpand = !state.formExpand;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setFormData(state, payload) {
            state.formData = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDetailStatistics(state, payload) {
            state.detailStatistics = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSearchParam(state, payload) {
            state.searchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDocumentList(state, payload) {
            state.documentList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDocumentPageInfo(state, payload) {
            state.documentPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedDocument(state, payload) {
            state.selectedDocument = payload;
            // console.log(state.selectedDocument);
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedDocumentRowKeys(state, payload) {
            state.selectedDocumentRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setPrintDocumentModelVisible(state, payload) {
            state.printDocumentModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },

        setDocumentMaterialList(state, payload) {
            state.documentMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //添加单据中的配件信息
        addDocumentMaterial(state, payload) {
            state.documentMaterialList.push(...payload);
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //移除单据中的配件信息
        removeDocumentMaterial(state, payload) {
            state.documentMaterialList = state.documentMaterialList.filter(el => !!!payload.find(ele => ele === el.key));
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //设置单据中选中的配件
        setSelectedDocumentMaterial(state, payload) {
            state.selectedDocumentMaterial = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedDocumentMaterialRowKeys(state, payload) {
            state.selectedDocumentMaterialRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },

        setAddMaterialModelVisible(state, payload) {
            state.addMaterialModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setMaterialSearchParam(state, payload) {
            state.materialSearchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //待选配件列表
        setMaterialList(state, payload) {
            state.materialList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setMaterialPageInfo(state, payload) {
            state.materialPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedMaterialList(state, payload) {
            state.selectedMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //添加已选配件
        addSelectedMaterial(state, payload) {
            // console.log(state, payload)
            // state.materialList = state.materialList.filter(el => el.id !== payload.id);
            state.selectedMaterialList.push(payload);
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //全选添加
        addSelectedMaterialAll(state, payload) {
            //拿到已选配件的id  
            let selectedId = state.documentMaterialList.map(item => item.detailedId);
            //过滤掉已添加配件和 销售数量 大于 退货数量 
            let newSeleedAllList = payload.filter(el => (selectedId.indexOf(el.detailedId) < 0 && el.returnNum < el.saleNum));
            state.selectedMaterialList = newSeleedAllList;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //删除已选配件
        removeSelectedMaterial(state, payload) {
            // state.materialList.push(payload);
            // state.selectedMaterialList = state.selectedMaterialList.filter(el => el.id !== payload.id);
            state.selectedMaterialList = state.selectedMaterialList.filter(el => el.key !== payload.key);
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //设置支付窗口显示
        setPaymentDrawerVisible(state, payload) {
            state.paymentDrawerVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        transSelectedSoItemListToRoItemList(state, ) {
            const mappedItems = state.selectedMaterialList.map(el => {
                let tmp = soItemTransToRoItem(el);
                const { returnNum, returnPrice, discount, } = tmp
                tmp.returnAmount = (returnNum * returnPrice).toFixed(2);
                tmp.payableAmount = (returnNum * returnPrice * discount / 100).toFixed(2);
                return tmp;
            })
            // console.log(mappedItems)
            state.documentMaterialList = [...state.documentMaterialList, ...mappedItems]
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        updateStatus(state, status) {
            state.selectedDocument = { ...state.selectedDocument, ...status }
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
    },
    effects: () => ({
        //加载单据列表
        async loadDocumentList({ showMsg = true, duration = 5, data }) {
            const funName = "加载销售退货单列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.findPage(data);
                const { list, statistics, ...page } = retData;
                const mappedList = list.map(el => ({
                    ...el,
                    key: el.id,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_RETURN_STATUS, el.orderStatus),
                    orderTypeName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_ORDER_TYPE, el.orderType),
                    invoiceTypeName: getDictNameByCode(DICT_KEY.CM_DICT.INVOICE_TYPE, el.invoiceType),
                    paymentStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_RETURN_PAY_STATUS, el.paymentStatus),
                }));
                this.setDocumentList(mappedList);
                this.setDocumentStatistic(statistics);
                const { pageNum = 1 } = page;
                this.setDocumentPageInfo({ ...page, pageNum: pageNum === 0 ? 1 : pageNum });
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadRo({ showMsg = true, duration = 5, data }) {
            const funName = "加载销售单单详细信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.findByIdOrCode(data);
                const { details, ...ro } = retData;
                const mappedList = details.map(el => ({
                    ...el,
                    key: el.id,
                    materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
                }))

                this.setSelectedDocument({
                    ...ro,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_RETURN_STATUS, ro.orderStatus),
                });
                this.setDocumentMaterialList(mappedList);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //导出销售退货单
        async exportRo({ showMsg = false, duration = 5, data }) {
            const funName = "导出销售退货单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.export(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //新增订单
        async insert({ showMsg = true, duration = 5, data }) {
            const funName = "新增销售退货单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.insert(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //修改订单
        async update({ showMsg = true, duration = 5, data }) {
            const funName = "修改销售退货单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.update(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //作废
        async disable({ showMsg = true, duration = 5, data }) {
            const funName = "销售单作废";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.disable(data);
                if (retData) {
                    this.updateStatus({
                        orderStatus: "029004",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_RETURN_STATUS, "029004")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },


        //结算
        async settle({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            const funName = "销售退货单结算";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.settle(data);
                if (retData) {
                    this.updateStatus({
                        orderStatus: "029003",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_RETURN_STATUS, "029003")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //库房确认
        async whConfirm({ showMsg = false, duration = 5, data }) {
            const funName = "库存确认";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.whConfirm(data);
                if (retData) {
                    this.updateStatus({
                        orderStatus: "029002",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_RETURN_STATUS, "029002")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //下载明细导入模板
        async downloadDetailTpl({ showMsg = false, duration = 5, data }) {
            const funName = "下载销售退货单明细导入模板";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleRoService.downloadDetailTpl(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //加载销售数据
        async loadSaleData({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            let retData = await SaleSoService.findDetailPage(data);
            const { list, statistic, ...pageInfo } = retData;
            const mappedList = list.map(el => ({
                ...el,
                key: el.detailedId,
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
            }));
            // console.log(mappedList)
            this.setMaterialList(mappedList);
            const { pageNum = 1 } = pageInfo;
            this.setMaterialPageInfo({ ...pageInfo, pageNum: pageNum === 0 ? 1 : pageNum });
        },
        //全选销售数据
        async loadSaleDataAll({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            let retData = await SaleSoService.findDetailPage(data);
            const { list, statistic, ...pageInfo } = retData;
            const mappedList = list.map(el => ({
                ...el,
                key: el.detailedId,
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
            }));
            this.addSelectedMaterialAll(mappedList);
        }
    })
};

const soItemTransToRoItem = el => {
    const {
        saleId, saleCode, materialId, materialCode, materialName, replaceNum, materialUnit, materialUnitName,
        saleNum, giftsNum, costPrice, salePrice, returnNum, warehouseId, warehouseName, shelfId, shelfCode, detailedId,
    } = el;
    return {
        key: detailedId,
        id: detailedId,
        detailedId,
        saleId,
        saleCode,
        materialId,
        materialCode,
        materialName,
        replaceNum,
        materialUnit,
        materialUnitName,
        costPrice,
        saleNum,//销售数量
        giftsNum,//赠品数量
        salePrice,//销售单价
        returnedNum: returnNum,//已退数量
        returnNum: 1,//退货数量
        returnPrice: !!salePrice ? salePrice : 0.00,//退货价格
        aggregateAmount: 0,//退货总金额
        discount: 100,//折扣
        payableAmount: 0,//应付金额

        warehouseId: !!warehouseId ? warehouseId : '空',
        warehouseName: !!warehouseName ? warehouseName : '空',
        shelfId: !!shelfId ? shelfId : '空',
        shelfCode: !!shelfCode ? shelfCode : '空',

        returnDesc: "无",
    };
}
export default saleRoModel;